<template>
  <mu-card class="blood-glucose-ranges">
    <mu-card-text v-if="!isLoading" class="top-label">{{ranges.total}} {{$t('message.visualizationBloodGlucoseHeader')}}</mu-card-text>
    <mu-card-text v-if="isLoading" class="top-label">{{$t('message.loadingText')}}</mu-card-text>
    <mu-card-text>
      <mu-row>
        <mu-col width="33" desktop="33" tablet="33">
          <div v-if="isLoading">
            <radial-progress
              data-id="radial-loading-1"
              :value="0"
              suffix="%"
              color="#0179d5"
            ></radial-progress>
          </div>
          <radial-progress
            v-if="!isLoading"
            data-id="radial-1"
            :value="lower"
            suffix="%"
            color="#0179d5"
          ></radial-progress>
          <div class="center">
            {{$t('message.labelBelowRange')}}
            <br/>
            {{ranges.lower}}
          </div>
        </mu-col>
        <mu-col width="33" desktop="33" tablet="33">
          <div v-if="isLoading">
            <radial-progress
              data-id="radial-loading-2"
              :value="0"
              suffix="%"
              color="#89C93B"
            ></radial-progress>
          </div>
          <radial-progress
            v-if="!isLoading"
            data-id="radial-2"
            :value="inRange"
            suffix="%"
            color="#89C93B"
          ></radial-progress>
          <div class="center">
            {{$t('message.labelInRange')}}
            <br/>
            {{ranges.in_range}}
          </div>
        </mu-col>
        <mu-col width="33" desktop="33" tablet="33">
          <div v-if="isLoading">
            <radial-progress
              data-id="radial-loading-3"
              :value="0"
              suffix="%"
              color="#89C93B"
            ></radial-progress>
          </div>
          <radial-progress
            v-if="!isLoading"
            data-id="radial-3"
            :value="upper"
            suffix="%"
            color="#E74C3C"
          ></radial-progress>
          <div class="center">
            {{$t('message.labelAboveRange')}}
            <br/>
            {{ranges.upper}}
          </div>
        </mu-col>
      </mu-row>
    </mu-card-text>
  </mu-card>
</template>

<script type="text/babel">

  import BloodGlucoseApi from '../../../../api/Tracking/BloodGlucose'
  import RadialProgress from "../../../RadialProgress/RadialProgress";
  import MuCircularProgress from "muse-ui/src/circularProgress/circularProgress";

  export default {
    components: {
      MuCircularProgress,
      RadialProgress
    },
    name: "blood-glucose-range",
    data() {
      return {
        isLoading: true,
        ranges: {
          total: 0
        }
      }
    },
    mounted() {
      let self = this;
      const now = moment();
      const fromDate = now.startOf('month').format('YYYY-MM-DD');
      const toDate = now.format('YYYY-MM-DD');
      self.$EventBus.$on('bgPusherReceived', function () {
        self.isLoading = true;
        BloodGlucoseApi.getBloodGlucoseRanges(fromDate, toDate)
          .then(function (response) {
            self.ranges = response.data.ranges;
            self.isLoading = false;
          })
          .catch(function (error) {

          })
      });
      BloodGlucoseApi.getBloodGlucoseRanges(fromDate, toDate)
        .then(function (response) {
          self.ranges = response.data.ranges;
          self.isLoading = false;
        })
        .catch(function (error) {

        })
    },
    computed: {
      lower() {
        let self = this;
        let totals = self.ranges.total;
        if (self.ranges.total === 0) {
          return 0;
        }
        return (self.ranges.lower / self.ranges.total) * 100;
      },
      inRange() {
        let self = this;
        let totals = self.ranges.total;
        if (self.ranges.total === 0) {
          return 0;
        }
        return (self.ranges.in_range / self.ranges.total) * 100;
      },
      upper() {
        let self = this;
        let totals = self.ranges.total;
        if (self.ranges.total === 0) {
          return 0;
        }
        return (self.ranges.upper / self.ranges.total) * 100;
      }
    }
  }
</script>
<style lang="less">
  .blood-glucose-ranges {
    .center {
      text-align: center
    }
    .top-label {
      color: black;
      padding-bottom: 0 !important;
      font-size: 16px;
    }
  }
</style>



// WEBPACK FOOTER //
// BloodGlucoseRange.vue?300bdd9f